import React from "react";
import "./premises.scss";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

const Premises = (props: ReferenciaContenido) => {
  const premisesData = props;

  return (
    <div className="m-premises">
      <div className="center">
        <div className="m-premises__title">
          <h2>{premisesData?.tituloGeneral}</h2>
        </div>
      </div>

      <div className="m-premises__container">
        <div className="m-premises__container__col">
          <div className="m-premises__container__col__img">
            <img
              src={
                premisesData?.referenciaPlantillaContenido[0]
                  ?.imagenPrincipal[0]?.file.url
              }
              alt={
                premisesData?.referenciaPlantillaContenido[0]
                  ?.imagenPrincipal[0]?.title
              }
            />
          </div>

          <h3>{premisesData?.referenciaPlantillaContenido[0]?.tituloBanner}</h3>
          <p>
            {
              JSON.parse(
                premisesData?.referenciaPlantillaContenido[0]?.descripcion?.raw
              ).content[0].content[0].value
            }
          </p>
        </div>
        <div className="m-premises__container__col">
          <div className="m-premises__container__col__img">
            <img
              src={
                premisesData?.referenciaPlantillaContenido[1]
                  ?.imagenPrincipal[0]?.file.url
              }
              alt={
                premisesData?.referenciaPlantillaContenido[1]
                  ?.imagenPrincipal[0]?.title
              }
            />
          </div>

          <h3>{premisesData?.referenciaPlantillaContenido[1]?.tituloBanner}</h3>
          <p>
            {
              JSON.parse(
                premisesData?.referenciaPlantillaContenido[1]?.descripcion?.raw
              ).content[0].content[0].value
            }
          </p>
        </div>
        <div className="m-premises__container__col">
          <div className="m-premises__container__col__img">
            <img
              src={
                premisesData?.referenciaPlantillaContenido[2]
                  ?.imagenPrincipal[0]?.file.url
              }
              alt={
                premisesData?.referenciaPlantillaContenido[2]
                  ?.imagenPrincipal[0]?.title
              }
            />
          </div>

          <h3>{premisesData?.referenciaPlantillaContenido[2]?.tituloBanner}</h3>
          <p>
            {
              JSON.parse(
                premisesData?.referenciaPlantillaContenido[2]?.descripcion?.raw
              ).content[0].content[0].value
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default Premises;
